/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inquiry_SentInputs */

const en_inquiry_sent = /** @type {(inputs: Inquiry_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inquiry Sent!`)
};

const es_inquiry_sent = /** @type {(inputs: Inquiry_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Consulta enviada!`)
};

const fr_inquiry_sent = /** @type {(inputs: Inquiry_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demande envoyée !`)
};

const de_inquiry_sent = /** @type {(inputs: Inquiry_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfrage gesendet!`)
};

const ja_inquiry_sent = /** @type {(inputs: Inquiry_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問い合わせが送信されました！`)
};

const zh_inquiry_sent = /** @type {(inputs: Inquiry_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`咨询已发送！`)
};

const ar_inquiry_sent = /** @type {(inputs: Inquiry_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم إرسال الاستفسار!`)
};

const id_inquiry_sent = /** @type {(inputs: Inquiry_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertanyaan Terkirim!`)
};

const it_inquiry_sent = /** @type {(inputs: Inquiry_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richiesta Inviata!`)
};

const ru_inquiry_sent = /** @type {(inputs: Inquiry_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запрос отправлен!`)
};

const pt_inquiry_sent = /** @type {(inputs: Inquiry_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta Enviada!`)
};

const ko_inquiry_sent = /** @type {(inputs: Inquiry_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의가 전송되었습니다!`)
};

/**
* | output |
* | --- |
* | "Inquiry Sent!" |
*
* @param {Inquiry_SentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const inquiry_sent = /** @type {((inputs?: Inquiry_SentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inquiry_SentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inquiry_sent(inputs)
	if (locale === "es") return es_inquiry_sent(inputs)
	if (locale === "fr") return fr_inquiry_sent(inputs)
	if (locale === "de") return de_inquiry_sent(inputs)
	if (locale === "ja") return ja_inquiry_sent(inputs)
	if (locale === "zh") return zh_inquiry_sent(inputs)
	if (locale === "ar") return ar_inquiry_sent(inputs)
	if (locale === "id") return id_inquiry_sent(inputs)
	if (locale === "it") return it_inquiry_sent(inputs)
	if (locale === "ru") return ru_inquiry_sent(inputs)
	if (locale === "pt") return pt_inquiry_sent(inputs)
	return ko_inquiry_sent(inputs)
});